import { LocaleMessages } from 'vue-i18n'

const paymentPtBrLocaleMessages: LocaleMessages = {
  subscription: {
    title: 'Assinatura',
    pluralTitle: 'Assinaturas'
  },
  subscriptionPayload: {
    field: {
      id: 'Id',
      customer: 'Cliente',
      planDescription: 'Descrição do Plano',
      status: 'Status',
      billingType: 'Forma de Pagamento',
      cycle: 'Periodicidade',
      value: 'Valor',
      nextDueDate: 'Próxima Cobrança',
      partner: 'Parceiro',
      groupSerial: 'N. de Série',
      invoiceAmount: 'Valor da Fatura',
      sellerId: 'Id do Vendedor',
      createdDate: 'Criado em'
    },
    alert: {
      command: {
        CREATE_ACCESS: 'Tem certeza que deseja criar o acesso para esta assinatura?'
      }
    },
    notification: {
      command: {
        CREATE_ACCESS: 'Acesso criado com sucesso.'
      }
    },
    value: {
      status: {
        ACTIVE: 'Ativo',
        EXPIRED: 'Expirado',
        INACTIVE: 'Inativo'
      },
      billingType: {
        UNDEFINED: 'Indefinido',
        BOLETO: 'Boleto',
        CREDIT_CARD: 'Cartão de Crédito',
        DEBIT_CARD: 'Cartão de Débito',
        TRANSFER: 'Transferência',
        DEPOSIT: 'Depósito',
        PIX: 'Pix'
      },
      cycle: {
        WEEKLY: 'Semanal',
        BIWEEKLY: 'Quinzenal',
        MONTHLY: 'Mensal',
        BIMONTHLY: 'Bimestral',
        QUARTERLY: 'Trimestral',
        SEMIANNUALLY: 'Semestral',
        YEARLY: 'Anual'
      },
      command: {
        CREATE_ACCESS: 'Criar Acesso'
      }
    }
  },
  customer: {
    title: 'Cliente',
    pluralTitle: 'Clientes'
  },
  customerPayload: {
    field: {
      id: 'Id',
      name: 'Nome',
      cpfCnpj: 'CPF / CNPJ',
      email: 'E-mail',
      phone: 'Telefone',
      stateInscription: 'Inscrição Estadual',
      groupSeries: 'Série',
      postalCode: 'CEP',
      address: 'Endereço',
      addressNumber: 'Número',
      complement: 'Complemento',
      province: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      country: 'País',
      createdDate: 'Criado em'
    }
  },
  partner: {
    title: 'Parceiro',
    pluralTitle: 'Parceiros'
  },
  partnerPayload: {
    field: {
      id: 'Id',
      name: 'Nome',
      cpfCnpj: 'CPF / CNPJ',
      email: 'E-mail',
      phone: 'Telefone',
      walletId: 'Id da Carteira',
      postalCode: 'CEP',
      address: 'Endereço',
      addressNumber: 'Número',
      complement: 'Complemento',
      province: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      country: 'País'
    }
  }
}

export default paymentPtBrLocaleMessages